'use strict'

class Util {
    constructor() {
        this.cookieBarCloseButton = null;
    }

    init() {
        this.cookieBarCloseButton = document.getElementById('cookie-law-info-bar-close');
        this.initCookieBarCloseButton();
        this.initYoutubeModalVideo();
        this.initStatCounter();
        this.initGlobalCounter();
        this.initPreventMobileNavClick();
        this.initThumbnailClickVideo();
        this.playLazyVideo();
        this.initCookieBannerDelay();
        if (jQuery("body").hasClass("single-event")) {
	        this.initGlobalTimer();
	        if (jQuery('.register-icon').length) {
		        this.initShowHidePenTool();
	        }
	    }
	    if (jQuery(".animated-diamond").length) {
			this.initDiamondAnimation();
	    }
        this.initOpenModalForm();
        this.initDemoPage();
        this.initHsForm();
        if ( jQuery(".tps-form-hubspot-form.hs-sticky-form-positions.hs-sticky-form").length ) {
			this.initStickyHsForm();
		}
        this.initMobileNav();
        if (jQuery(".startConfetti").length) {
			this.initConfettiEffect();
	    }
	    if (jQuery(".parallax-section").length) {
			this.initSliderEffect();
	    }
	    if (jQuery(".scroll-panels-section").length) {
			this.initscrollAnimation();
	    }
	    this.initStickybar();
	    if (jQuery(".youtube-shorts").length || jQuery(".youtube-videos").length) {
			this.initYTvideos();
	    }
		if ( jQuery(".tps-logo-parade.scrolling-logos-on").length ) {
			this.initLogoParadeSlider();
		}
		if ( jQuery(".image-modal-wrapper").length ) {
			this.initImagePop();
		}
		if ( jQuery(".event-agenda-section").length ) {
			this.initEventAgenda();
		}
		if ( jQuery(".upt-faq-section").length ) {
			this.initFAQ();
		}

		this.progressBar();
		this.initAllocLogin();
		this.initAllocProductLogin();
    }

    initCookieBannerDelay() {
		jQuery(function() {
			var timeDelay = cookieDelay * 1000;
			CLI.bar_elm.hide();
			if (CLI.settings.notify_animate_show) {
				CLI.bar_elm.css('visibility', 'hidden');
			}
			setTimeout(function() {
				if (!CLI_Cookie.read(CLI_ACCEPT_COOKIE_NAME)) {
					if (CLI.settings.notify_animate_show) {
						CLI.bar_elm.hide();
						CLI.bar_elm.css('visibility', 'visible');
						CLI.bar_elm.slideDown(CLI.settings.notify_animate_show);
					} else {
						CLI.bar_elm.show();
					}
				}
			}, timeDelay);

			jQuery(document).on('click', '.wt-cli-manage-consent-link, .cli_manage_current_consent', function() {
				CLI.bar_elm.css('visibility', 'visible');
			});
		});
	}

	initCookieBarCloseButton() {
		const self = this;

		if (self.cookieBarCloseButton) {
			self.cookieBarCloseButton.addEventListener('click', function(e) {
				if (window.CLI && window.CLI.bar_elm) {
					window.CLI.bar_elm.hide();
				}
			});
		}
	}
	initYoutubeModalVideo() {
		jQuery(document).on('closed.zf.reveal', '.youtube-video', function () {
		  	play_stop_YT_video(this);
		});
		jQuery(document).on('open.zf.reveal', '.youtube-video', function () {
		  	play_stop_YT_video(this, true);
		});
		function play_stop_YT_video(elem, play = false) {
		  	var modal = jQuery(elem),
			iframe = modal.find('iframe')[0];
			if(play) {
				src = iframe.src.replace('?autoplay=0', '?autoplay=1');
			} else {
				src = iframe.src.replace('?autoplay=1', '?autoplay=0');
			}
		  	iframe.contentWindow.location.replace(src);
		}
	}

	initStatCounter() {

		const meters = document.querySelectorAll("svg[data-value] .meter");

		meters.forEach((path) => {
		  let length = path.getTotalLength();
		  let value = parseInt(path.parentNode.getAttribute("data-value"));
		  let to = length * ((100 - value) / 100);
		  path.getBoundingClientRect();
		  path.style.strokeDashoffset = Math.max(0, to);
		  path.nextElementSibling.textContent = `${value}%`;
		});
	}

	initGlobalCounter(){
		var counterSection = document.querySelector('.counter-section .dd-grid-columns-items-item .counter-wrapper .counter');
		if(counterSection) {
		  
		  let counter_options = {
		    root: null,
		    rootMargin: "0px 0px 0px 0px",
		  };
		  
		  var counter_intersectionObserver = new IntersectionObserver(function(entries) {
		    if (entries[0].target.classList.contains('initiated')) return;
		      if (entries[0].intersectionRatio <= 0) return;
		      entries[0].target.classList.add('initiated');
		    
		    //Counter Script Start here
		    const counters = document.querySelectorAll(".counter");
		    counters.forEach((counter) => {
		      counter.innerText = "0";
		      const updateCounter = () => {
		        const target = +counter.getAttribute("data-target");
		        const count = +counter.innerText;
		        const increment = target / 100;
		        if (count < target) {
		          counter.innerText = `${Math.ceil(count + increment)}`;
		          setTimeout(updateCounter, 30);
		        } else counter.innerText = target;
		      };
		      updateCounter();
		    });
		    //Counter Script End here

		  }, counter_options);
		  counter_intersectionObserver.observe(counterSection);
		}
	}

	initGlobalTimer() {
	
		function makeTimer() {
			var endTime = jQuery('.tps-internal-billboard #timer').attr("event");			
			var endTime = (Date.parse(endTime) / 1000);

			var now = new Date();
			now = (Date.parse(now) / 1000);

			var timeLeft = endTime - now;

			var days = Math.floor(timeLeft / 86400);
			if(days < 0) {
				days = 0;
			}
			var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
			var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
			var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

			if (hours < 10) { hours = parseInt(0) + hours; }
			if (minutes < 10) { minutes = parseInt(0) + minutes; }
			if (seconds < 10) { seconds = parseInt(0) + seconds; }

			jQuery("#days").html(parseInt(days) + "");
			jQuery("#hours").html(hours);
			jQuery("#minutes").html(minutes);
			jQuery("#seconds").html(seconds);

			if(days <= 0 && (hours < 0 || minutes < 0)) {
				jQuery('.tps-internal-billboard #timer').css("display","none");
			} else {
				setTimeout(function() { makeTimer(); }, 30000);
			}
		}
		makeTimer();
	}
	initDiamondAnimation() {
		var smallDiamond = jQuery('.animated-diamond .small-diamond');
		var pinkSmallDiamond = jQuery('.animated-diamond .pink-small-diamond');
		var uptempoDiamond = jQuery('.animated-diamond .uptempo-diamond');
		var blueDiamond = jQuery('.animated-diamond .blue-diamond');
		var pinkUptempoDiamond = jQuery('.animated-diamond .pink-uptempo-diamond');
		var pinkDiamond = jQuery('.animated-diamond .pink-diamond');
		var eventLocation = jQuery('.animated-diamond .event-location');
		function isScrolledIntoView(elem) {
			if(elem.length) {
				var docViewTop = jQuery(window).scrollTop();
				var docViewBottom = docViewTop + jQuery(window).height();
				var elemTop = elem.offset().top;
				var elemBottom = elemTop + elem.height();
		  }
		  return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
		}
		if(isScrolledIntoView(smallDiamond) ) {
			smallDiamond.addClass('fade-left');
		}
		if(isScrolledIntoView(pinkSmallDiamond) ) {
			pinkSmallDiamond.addClass('fade-left');
		}
		if(isScrolledIntoView(uptempoDiamond)) {
			uptempoDiamond.addClass('fade-left');
		}
		if(isScrolledIntoView(pinkUptempoDiamond)) {
			pinkUptempoDiamond.addClass('fade-left');
		}
		jQuery(window).scroll(
			function() {
			if(isScrolledIntoView(smallDiamond)) {
				smallDiamond.addClass('fade-left');
			}
			if(isScrolledIntoView(uptempoDiamond)) {
				uptempoDiamond.addClass('fade-left');
			}
			if(isScrolledIntoView(blueDiamond)) {
				blueDiamond.addClass('fade-left');
			}
			if(isScrolledIntoView(pinkSmallDiamond)) {
				pinkSmallDiamond.addClass('fade-left');
			}
			if(isScrolledIntoView(pinkUptempoDiamond)) {
				pinkUptempoDiamond.addClass('fade-left');
			}
			if(isScrolledIntoView(pinkDiamond)) {
				pinkDiamond.addClass('fade-right');
			}
			if(isScrolledIntoView(eventLocation)) {
				eventLocation.addClass('fade-right');
			}
		});
	}
	initShowHidePenTool() {
		jQuery(document).scroll(function() {
		  var y = jQuery(this).scrollTop();
		  if (y > 250) {
		    jQuery('.register-icon').fadeIn();
		  } else {
		    jQuery('.register-icon').fadeOut();
		  }
		});

		jQuery(window).scroll(function() {
		    if (isScrolledIntoView('.social-icons-items') )
		      jQuery('.register-icon').css('visibility','hidden');
		    else{
		      jQuery('.register-icon').css('visibility','visible');
		    }
		});

		function isScrolledIntoView(elem)
		{
		  var docViewTop = jQuery(window).scrollTop();
		  var docViewBottom = docViewTop + jQuery(window).height();
		  var elemTop = jQuery(elem).offset().top;
		  var elemBottom = elemTop + jQuery(elem).height();
		  return ((elemTop < docViewBottom));
		}
	}
	initPreventMobileNavClick() {
		var width = jQuery(window).width();
		if(width < 1023) {
		    jQuery(".tps-nav-main-mobile .accordion-menu.menu>li>a:not(.login-cta):not(.direct-link)").click(function(e) {
		        e.preventDefault();
		        jQuery(this).siblings(".submenu-toggle").trigger("click");
		    });
		}
	}
	initMobileNav() {
		jQuery(document).ready(function() {
			var width = jQuery(window).width();
			if(width < 1023) {
				jQuery('.tps-header-toggle').click(function() {
					jQuery('body').toggleClass('disable-scroll');
				});
				jQuery('.tps-nav-main-mobile-wrapper .submenu-toggle').bind('click', function() {
				  jQuery(this).closest('.tps-nav-main-mobile').toggleClass('has-active-item');
				});

				jQuery('.tps-nav-main-mobile .back-menu').click(function() {
				  jQuery('.tps-nav-main-mobile-wrapper .is-active')
				    .closest('.is-accordion-submenu-parent')
				    .find('.submenu-toggle').trigger('click');  
				});

				jQuery('.tps-nav-main-subitem-link[href*="#"]').bind('click', function() {
				    jQuery('.tps-header-toggle').trigger('click');
				});

				jQuery('.close-icon').click(function() {
					jQuery('.tps-header-toggle').trigger('click');
				});
			}
		});
	}

	initOpenModalForm() {
		jQuery('a[href="#modalForm"]').click(function(event) {
		  event.preventDefault();
		  jQuery('#modalForm').foundation('open');
		});
	}

	initDemoPage() {
		var footerCTA = jQuery(".page-id-10037 #footer .tps-nav-footer .button");
		if(footerCTA.length) {
			footerCTA.attr("href","#connect-with-us");
		}
	}
	initHsForm() {

		var formIntersectionObserver = new IntersectionObserver(function(entries) {
			entries.forEach(entry => {
				if (entry.intersectionRatio <= 0 && !jQuery(entry.target).hasClass('hbspt-multi-step-form')) return;

				var $hubspt_form = jQuery(entry.target);
				if(!$hubspt_form.hasClass('hs-initialised')) {
					var settings = $hubspt_form.data('settings');
					hsCreate(settings.portalid, settings.formid, settings.sfdccampaignid, settings.version, $hubspt_form.attr("id"));
					$hubspt_form.addClass('hs-initialised');
				}
			});
		}, {rootMargin: "0px 0px 900px 0px"});

		const hs_forms = document.querySelectorAll('.hsform-placeholder');
		if (hs_forms.length) {
			hs_forms.forEach((el) => {
				formIntersectionObserver.observe(el);
			});
		}

		function hsCreate(portalId, formId, sfdcCampaignId, version, id) {

			if(typeof(jQuery) != 'undefined' && typeof(hbspt) != 'undefined') {
				hbspt.forms.create({
					region: "na1",
					portalId: portalId,
					formId: formId,
					sfdcCampaignId: sfdcCampaignId,
					version: version,
					target: "#"+id,
					onBeforeFormInit: function() {
						if(jQuery('.tps-form-hubspot-full-width').length || jQuery('.new-form-style').length ) {
							jQuery('body').append('<style>.hbspt-form .legal-consent-container .hs-richtext { display: none;}.hbspt-form .legal-consent-container .hs-richtext:first-child { display: block;margin-bottom: 7px;}</style>');
						}
					},
					onFormReady: function () {
						if(jQuery('.tps-form-hubspot').length) {
							jQuery('.hs-form-field').each(function(){
								var label = jQuery(this).find('label span').text(),
									$input_elem = jQuery(this).find('.input input, .input textarea'),
									placeholder_text = $input_elem.attr('placeholder');
								if(!placeholder_text || placeholder_text == '') {
									$input_elem.attr('placeholder',label);
								}
							});
						}

						var $hs_form = jQuery('.hbspt-form');
						if($hs_form.find('.hs-richtext').length && ( jQuery('.tps-form-hubspot-full-width').length || jQuery('.tps-form-hubspot.new-form-style').length ) ) {
							jQuery('.legal-consent-container .hs-dependent-field').parent().addClass('hs_chkbox_block');
						  let hs_terms_conditions = $hs_form.find('.hs-richtext:eq(0)').html();
						  let hs_more_info = $hs_form.find('.hs-richtext:eq(1)').html();
						  let kpmg_privacy_policy = '<p>By clicking "submit", you acknowledge and agree that the personal information you provide may be shared with KPMG LLP, the U.S. member firm of the KPMG global organization of independent member firms. You further understand that KPMG LLP may process your personal information pursuant to KPMG LLP&apos;s <a href="https://home.kpmg/us/en/home/misc/privacy.html" target="_blank">Privacy Statement</a> and may contact you regarding the firm&apos;s services.</p>';
						  if($hs_form.find('a[href="#communication_consent_text"]').length) {
							$hs_form.find('a[href="#communication_consent_text"]').append('<div class="communication_consent_text">'+hs_terms_conditions+'</div>');
						  }
						  if($hs_form.find('a[href="#more_info"]').length) {
							$hs_form.find('a[href="#more_info"]').append('<div class="more_info">'+hs_more_info+'</div>');
						  }
						  if($hs_form.find('a[href="#kpmg_privacy_policy"]').length) {
							$hs_form.find('a[href="#kpmg_privacy_policy"]').append('<div class="kpmg-privacy-policy">'+kpmg_privacy_policy+'</div>');
						  }
						  $hs_form.find('a').each(function() {
							var anchor_href = jQuery(this).attr('href');
							if (anchor_href && anchor_href.indexOf('#communication_consent_text') !== -1) {
								jQuery(this).attr('href', '#communication_consent_text');
								jQuery(this).append('<div class="communication_consent_text">'+hs_terms_conditions+'</div>');
							}
							if (anchor_href && anchor_href.indexOf('#more_info') !== -1) {
								jQuery(this).attr('href', '#more_info');
								jQuery(this).append('<div class="more_info">'+hs_more_info+'</div>');
							}
						  });
						}
					},
					onBeforeFormSubmit : function($form) {

						//For Multi Step Form
						var $currentForm = $form.closest('.tps-form-hubspot-form'),
						$nextForm = $currentForm.next('.tps-multi-step-form');

						if ($nextForm.length) {
							var hbspotFormEmail = $form.find("input[name='email']").val();

							if (hbspotFormEmail) {
								$currentForm.hide();
								$nextForm.show();

								var $nextFormMailField = $nextForm.find(".hbspt-form.hs-initialised input[name='email']");

								if ($nextFormMailField.length) {
									$nextFormMailField.val(hbspotFormEmail).change();
								}
							}
						}
					},
					onFormSubmitted: function($form) {
						$form.closest('.tps-form-hubspot-form').find('.tps-form-hubspot-form-header').hide();
						var formOffset = $form.offset().top;
						var scrollPosition = formOffset - 250;
						jQuery('html, body').animate({
						    scrollTop: scrollPosition
						}, 1000);
						//For Blue Print Post type

						var bodyTag = jQuery('body');
						var bluePrintPostContainer = bodyTag.find('.single-blueprint-post-container').length;
						var ghostFormContainer = bodyTag.find('.ghost-form').length;

						if (bluePrintPostContainer || ghostFormContainer) {
							function setCookie(cookieName, cookieValue, expirationDays, path) {
							    var expires = new Date();
							    expires.setDate(expires.getDate() + expirationDays);
							    document.cookie = cookieName + "=" + cookieValue + "; expires=" + expires.toUTCString() + "; path="+ path;
							}
							var currentPagePath = window.location.pathname;
							var ghostFormSubmittedKey = 'ghostFormSubmitted_' + currentPagePath;
							if (ghostFormContainer && !sessionStorage.getItem(ghostFormSubmittedKey)) {
								setCookie('ghostFormSubmitted', 'true', 7, currentPagePath);
								sessionStorage.setItem(ghostFormSubmittedKey, 'true');
							}
							if (bluePrintPostContainer) {
								setCookie('blueprintFormSubmitted', 'true', 7, "/");
							}
							jQuery('.tps-form-hubspot-full-width.blueprint-form, .tps-form-hubspot-full-width.ghost-form').hide();
						    jQuery('.blurred-section').removeClass('blurred-section').css('filter', '');
						    jQuery('.form-before-section').removeClass('form-before-section').removeAttr('style');
						}
					}
				});
			} else {
				setTimeout(function(){ hsCreate(portalId, formId, sfdcCampaignId, version, id); }, 1e3);
			}
		}

		window.addEventListener("message", function(event) {
			if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
				var formData = event.data.data;
				var emailFilter = formData.filter(function(data) {
					return data.name == 'email';
				});
				var phoneFilter = formData.filter(function(data) {
					return data.name == 'phone';
				});
				if(emailFilter.length && phoneFilter.length) {
					UPT_GA_Events.formSubmissions('', '', emailFilter[0].value+'|'+phoneFilter[0].value);
				}
			}
		});
	}

	initStickyHsForm() {
	    const $sticky_form = jQuery('.tps-form-hubspot-form');
	    const $sidebar = jQuery('.tps-form-hubspot-sidebar');
	    const $header = jQuery('.tps-header');
	    const formTopAttr = $sticky_form.attr('data-top');
	    const formTop = formTopAttr ? parseInt(formTopAttr) : null;
	    const stickyStart = formTop || 0;  // You can define where the sticky behavior starts, default is formTop

	    if ($sticky_form.length && formTop !== null && !isNaN(formTop) && $sidebar.length && $header.length) {
	        function handleScroll() {
	            if (jQuery(window).width() <= 1000) {
	                // Reset styles on small screens
	                $sticky_form.css({ position: 'static', top: 'auto' });
	                return;
	            }

	            const scrollY = jQuery(window).scrollTop();
	            const sidebarBottom = $sidebar.offset().top + $sidebar.outerHeight();
	            const formHeight = $sticky_form.outerHeight();
	            const headerRect = $header[0].getBoundingClientRect();
	            const headerHeight = $header.outerHeight();
	            const formRect = $sticky_form[0].getBoundingClientRect();
	            const formTopInView = formRect.top;
	            const headerOverlapsForm = headerRect.bottom >= formTopInView;
	            const topOffset = headerOverlapsForm ? headerHeight : 0;

	            if (scrollY >= stickyStart) {
	                if (scrollY + formHeight >= sidebarBottom) {
	                    $sticky_form.css({
	                        position: 'absolute',
	                        top: (sidebarBottom - formHeight) + 'px'
	                    });
	                } else {
	                    $sticky_form.css({
	                        position: 'fixed',
	                        top: topOffset + 'px'
	                    });
	                }
	            } else {
	                $sticky_form.css({
	                    position: 'absolute',
	                    top: stickyStart + 'px'
	                });
	            }
	        }

	        // Initial setup
	        handleScroll();

	        // Add listeners
	        jQuery(window).on('scroll resize', handleScroll);
	    }
	}

	playLazyVideo() {
		var lazyVideoObserver = new IntersectionObserver(function(entries) {
			entries.forEach(entry => {
				if (entry.intersectionRatio <= 0) return;

				var $video = jQuery(entry.target);
				if(!$video.hasClass('lazyloaded')) {
					var $source = $video.find('source');
					$source.attr('src', $source.data('src'));
					$video.addClass('lazyloaded');
					$video[0].load();
				}
			});
		}, {rootMargin: "0px 0px 500px 0px"});

		const lazy_videos = document.querySelectorAll('.lazy-video');
		if (lazy_videos.length) {
			lazy_videos.forEach((el) => {
				lazyVideoObserver.observe(el);
			});
		}
	}

	initThumbnailClickVideo() {
	  jQuery('.thumbnail-video[poster], .internal-video-play-icon').click(function() {
	  	var $play_icon_parent = jQuery(this).closest('.internal-video, .video-embed-container');
	  	var $video_elem = $play_icon_parent.find('video');
	  	var $play_elem = $play_icon_parent.find('.internal-video-play-icon');
	  	if ($play_elem.length) {
	  		$play_elem.hide();
	  	}
	    var videoSrc = $play_icon_parent.find('source[data-src]');
	    if(videoSrc.length) {
			let source = videoSrc.data('src');
			videoSrc.attr('src',source).removeAttr('data-src');
			$video_elem.attr('controls','').attr('autoplay',true);
			$video_elem[0].load();
	    }
	  });

	  if(jQuery(".mp4-video-embed.play-in-modal").length) {

	  	var modalHtml = '<div class="reveal large video-modal-play" id="video-popup" data-reveal><div class="video-modal-content" style="padding: 25px;"></div><button class="close-button" data-close aria-label="Close modal" type="button"><span aria-hidden="true">&times;</span></button></div>';

	  	jQuery('body').append(modalHtml);

	  	var videoContentTarget = jQuery('.video-modal-play');
	   	var videoModalInstance = new Foundation.Reveal(videoContentTarget);

  		jQuery('.modal-thumbnail, .modal-play-icon').click(function() {

			var videoUrl = jQuery(this).closest('.video-embed-container-modal').attr('data-video-url');

	   		var videoTag = '<video width="100%" class="thumbnail-video" controls="controls" autoplay="autoplay"> <source type="video/mp4" src="'+videoUrl+'"></video>';
	   		jQuery(".video-modal-content").html(videoTag);

        	videoModalInstance.open();
		});

		jQuery('.video-modal-play').on('closed.zf.reveal', function() {
		    jQuery(this).find('video').remove();
		});

	  }

	}

	initConfettiEffect() {

		let isConfettiRunning = false;
		
		class Progress {
			constructor(param = {}) {
				this.timestamp = null;
				this.duration = param.duration || Progress.CONST.DURATION;
				this.progress = 0;
				this.delta = 0;
				this.isLoop = !!param.isLoop;

				this.reset();
			}

		  	static get CONST() {
			    return {
			      DURATION: 1000
			    };
		  	}

			reset() {
				this.timestamp = null;
			}

			start(now) {
				this.timestamp = now;
			}

		  	tick(now) {
			    if (this.timestamp) {
			      this.delta = now - this.timestamp;
			      this.progress = Math.min(this.delta / this.duration, 1);

			      if (this.progress >= 1 && this.isLoop) {
			        this.start(now);
			      }

			      return this.progress;
			    } else {
			      return 0;
			    }
		  	}
		}

		class Confetti {
			constructor(param) {
				this.parent = param.elm || document.body;
				this.canvas = document.createElement("canvas");
				this.ctx = this.canvas.getContext("2d");
				this.width = param.width || this.parent.offsetWidth;
				this.height = param.height || this.parent.offsetHeight;
				this.length =  400 || param.length || Confetti.CONST.PAPER_LENGTH;
				this.yRange = param.yRange || this.height;
				this.progress = new Progress({
					duration: param.duration,
					isLoop: false
				});

				this.rotationRange =
					typeof param.rotationRange === "number" ? param.rotationRange : 10;
				this.speedRange =
					typeof param.speedRange === "number" ? param.speedRange : 10;
				this.sprites = [];

				this.canvas.style.cssText = [
					"display: block",
					"position: fixed",
					"top: 0",
					"left: 0",
					"height: 100vh",
					"pointer-events: none"
				].join(";");

				this.render = this.render.bind(this);

				this.build();

				this.parent.appendChild(this.canvas);
				this.progress.start(performance.now());

				requestAnimationFrame(this.render);
			}

			static get CONST() {
				return {
					SPRITE_WIDTH: 9,
					SPRITE_HEIGHT: 16,
					PAPER_LENGTH: 250,
					DURATION: 10,
					ROTATION_RATE: 10,
					COLORS: [
						"#210532",
						"#6126EF",
						"#A98DFF",
						"#CBED69",
						"#210532",
						"#6126EF",
						"#A98DFF",
						"#CBED69",
						"#210532",
						"#6126EF",
						"#A98DFF",
						"#CBED69",
						"#210532",
						"#6126EF",
						"#A98DFF",
						"#CBED69",
						"#210532",
						"#6126EF",
						"#A98DFF",
						"#CBED69"
					]
				};
			}

			build() {
				for (let i = 0; i < this.length; ++i) {
					let canvas = document.createElement("canvas"),
					ctx = canvas.getContext("2d");

					canvas.width = Confetti.CONST.SPRITE_WIDTH;
					canvas.height = Confetti.CONST.SPRITE_HEIGHT;

					canvas.position = {
						initX: Math.random() * this.width,
						initY: -canvas.height - Math.random() * this.yRange
					};

					canvas.rotation =
					this.rotationRange / 2 - Math.random() * this.rotationRange;
					canvas.speed =
					this.speedRange / 2 + Math.random() * (this.speedRange / 2);

					ctx.save();
					ctx.fillStyle =
					Confetti.CONST.COLORS[
					  (Math.random() * Confetti.CONST.COLORS.length) | 0
					];
					ctx.fillRect(0, 0, canvas.width, canvas.height);
					ctx.restore();

					this.sprites.push(canvas);
				}
			}

			render(now) {
				
				let progress = this.progress.tick(now);

				this.canvas.width = this.width;
				this.canvas.height = this.height;

				for (let i = 0; i < this.length; ++i) {
				  this.ctx.save();
				  this.ctx.translate(
				    this.sprites[i].position.initX +
				      this.sprites[i].rotation * Confetti.CONST.ROTATION_RATE * progress,
				    this.sprites[i].position.initY + progress * (this.height + this.yRange)
				  );
				  this.ctx.rotate(this.sprites[i].rotation);
				  this.ctx.drawImage(
				    this.sprites[i],
				    (-Confetti.CONST.SPRITE_WIDTH *
				      Math.abs(Math.sin(progress * Math.PI * 2 * this.sprites[i].speed))) /
				      2,
				    -Confetti.CONST.SPRITE_HEIGHT / 2,
				    Confetti.CONST.SPRITE_WIDTH *
				      Math.abs(Math.sin(progress * Math.PI * 2 * this.sprites[i].speed)),
				    Confetti.CONST.SPRITE_HEIGHT
				  );
				  this.ctx.restore();
				}
				
				requestAnimationFrame(this.render);
			}
		}

		function startConfetti() {
			if (isConfettiRunning) {
				return;
			}

			isConfettiRunning = true;

			const DURATION = 3000,
			LENGTH = 120;

			new Confetti({
				width: window.innerWidth,
				height: window.innerHeight,
				length: LENGTH,
				duration: DURATION
			});

			setTimeout(() => {
				isConfettiRunning = false;
			}, DURATION / 2);

			setTimeout( () => {
				jQuery('canvas').hide();
			}, DURATION );
		};

	    jQuery(".startConfetti").on("click", startConfetti);
	}

	initSliderEffect() {

		var width = jQuery(window).width();

		if( width > 1023) {

		window.addEventListener("scroll", handleScroll);

		const all_pos = [];
		jQuery('.parallax-section .parallax-section-content-column .wrapper').each(function() {
		  var pos = this.getBoundingClientRect();
		  all_pos.push(pos);
		});
		
			function handleScroll() {
			  jQuery('.parallax-section .parallax-section-content-column .wrapper').each(function(index) {
			    var $elem = jQuery(this);
			    var wrapperRect = all_pos[index];
			    var pos = this.getBoundingClientRect();

			    var wrapperWidth = wrapperRect.width;

			    translateX = ( $elem.offset().top - 200 - window.pageYOffset);
			    progress = 1 - translateX / wrapperWidth,
			    opacity = progress;

			    if(translateX <= 0 ) {
			      translateX = 0;
			    }

			    if(pos.y - window.innerHeight < 0) {
			      $elem.css({'transform' : 'translateX(' + translateX + 'px)', 'opacity' : opacity });
			    }
			  });
			}
		}
	}

	initscrollAnimation() {
		jQuery(".scroll-panels-section .tabs-wrapper .tabs-title").click(
		  function () {

			var $elem = jQuery(this),
			$parent = $elem.closest('.scroll-panels-section');
			$parent.addClass('user-interacted');

		    $parent.find(".tabs-title, .image-wrapper").removeClass("is-active");

		    $elem.addClass("is-active");

		    var tab_id = $elem.attr('id');

		    jQuery("#tab_"+tab_id).addClass("is-active");

		    $video = jQuery("#tab_"+tab_id).find('video');
		    if($video.length) {
		    	$video[0].load();
		    }

		  },
		);

		var width = jQuery(window).width();

		if( width > 1100) {

			jQuery('.scroll-panels-section-wrapper .scroll-on').each(function() {
			  var tl = gsap.timeline({
			    scrollTrigger: {
			      trigger: this,
			      start: "top 120px",
			      pin: true,
			      end: "+=2000",
			      onUpdate: getCurrentSection,
			      toggleClass: 'active'
			    }
			  });
			});

			function getCurrentSection(progress) {
				var $elem = jQuery(progress.trigger);
				var tab_length = $elem.find('.tabs-title').length;
				var image_wrapper_length = $elem.find('.image-wrapper').length;
				active_tab = parseInt(tab_length * progress.progress);

				$elem.find(".tabs-title, .image-wrapper").removeClass("is-active");

				$elem.find('.tabs-title:eq('+ active_tab + '), .image-wrapper:eq('+ active_tab +')').addClass('is-active');
			}
		}


		const autoplayTabsOptions = {
		   threshold: 0,
		   rootMargin: "0px 0px -100px 0px"
		};
		const autoplayTabsObserver = new IntersectionObserver((entries, autoplayTabsObserver) => {
		   entries.forEach(entry => {
		        if (entry.isIntersecting) {
		            autoplayTabs(entry.target);
		            autoplayTabsObserver.unobserve(entry.target);
		       }
		   });
		}, autoplayTabsOptions);
		function autoplayTabs(elem) {
		    var $elem = jQuery(elem);
		    if(!$elem.closest('.scroll-panels-section').hasClass('user-interacted')) {
		        var $active_tab = $elem.find('.tabs-title.is-active'),
		        $active_tab_content = $elem.find('.image-wrapper.is-active'),
		        $next_tab = $active_tab_content.next();
		        if($next_tab.length) {
		            $active_tab_content.removeClass('is-active');
		            $active_tab.removeClass('is-active');
		            $next_tab.addClass('is-active');
		            $active_tab.closest('.tabs-wrapper').next().find('.tabs-title').addClass('is-active');
		            setTimeout(function() { autoplayTabs(elem) }, 2000);
		        }
		    }
		}
		var $autoplayTabs = jQuery('.scroll-panels-section.autoplay-on .scroll-panels-section-wrapper');
		if($autoplayTabs.length) {
		    $autoplayTabs.each(function() {
		        autoplayTabsObserver.observe(this);
		    }); 
		}

		// LightBox Scripts
		var $section = jQuery(".scroll-panels-section.lightbox-on");
		var elementID = $section.attr('id');
		if (jQuery(".scroll-panels-section.lightbox-on").length) {

			var $section = jQuery(".scroll-panels-section.lightbox-on");
			var $lightboxsection = jQuery("#lightbox");
			var $lightboxBlock;

		    const $lightbox 	 = $lightboxsection;
		    const $lightboxImage = $lightboxsection.find("#lightbox-image");
		    const $lightboxVideo = $lightboxsection.find("#lightbox-video");
		    const $imageCaption  = $lightboxsection.find("#lightbox-caption");
		    const $closeButton 	 = $lightboxsection.find("#close-button");
		    const $prevButton 	 = $lightboxsection.find("#prev-button");
		    const $nextButton 	 = $lightboxsection.find("#next-button");

		    var currentImageIndex = 0;

		    function openLightbox(index) {
				var $lightboxBlockIndex = $lightboxBlock.eq(index);
				$lightboxImage.hide();
				$lightboxVideo.hide();
				if($lightboxBlockIndex.find('video').length){
					var $video = $lightboxBlockIndex.find('video'),
						videoUrl = $video.find('source').attr("data-src");
					$lightboxVideo.find('source').attr('src', videoUrl);
					$lightboxVideo[0].load();
					$lightboxVideo.show();
				} else {
					var $imgElem = $lightboxBlockIndex.find('img'), 
						$imageUrl = $imgElem.attr("data-src");
					if(!$imageUrl) {
						$imageUrl = $imgElem.attr("src");
					}
			        var imageCaption = $imgElem.attr("caption");
			        $lightboxImage.attr("src", $imageUrl);
			        if(!imageCaption){
			        	imageCaption = '';
			        }
			        $imageCaption.text(imageCaption);	
					$lightboxImage.show();
				}
				
		        $lightbox.fadeIn(500);
		        $lightbox.addClass("video-modal-open");
		        currentImageIndex = index;
		    }

		    function closeLightbox() {
		        $lightbox.fadeOut(500);
		        $lightbox.removeClass("video-modal-open");
		    }

		    function showNextImage() {
		        if (currentImageIndex < $lightboxBlock.length - 1) {
		            currentImageIndex++;
		            openLightbox(currentImageIndex);
		        }
		    }

		    function showPrevImage() {
		        if (currentImageIndex > 0) {
		            currentImageIndex--;
		            openLightbox(currentImageIndex);
		        }
		    }

		    $section.find(".image-wrapper").on("click", function () {
		    	var $elem = jQuery(this);
		    	currentImageIndex = 0;

		    	$lightboxBlock = $elem.closest('.scroll-panels-section').find('.image-wrapper');
		        openLightbox($lightboxBlock.index(this));
		    });

		    $closeButton.on("click", closeLightbox);
		    jQuery("#lightbox").on("click", function(e) {
		    	if(!jQuery(e.target).hasClass('lightbox-image') && !jQuery(e.target).hasClass('lightbox-caption') && !jQuery(e.target).hasClass('lightbox-nav' )  && !jQuery(e.target).hasClass('nav-button' ) && !jQuery(e.target).hasClass('emoji') && !jQuery(e.target).hasClass('lightbox-nav-img')) {
		    		closeLightbox();
		    	}

		    });
		    $nextButton.on("click", showNextImage);
		    $prevButton.on("click", showPrevImage);

		    jQuery(document).on("keydown", function (event) {
		        if (event.key === "Escape") {
		            closeLightbox();
		        } else if (event.key === "ArrowRight") {
		            showNextImage();
		        } else if (event.key === "ArrowLeft") {
		            showPrevImage();
		        }
		    });

		}
	}
	initStickybar() {
		jQuery(document).ready(function() {
		var width = jQuery(window).width();
		var $gt_elem = jQuery('.gt_switcher_wrapper');
		if(width > 1023){
		    jQuery(window).scroll(function() {
		        var scrollPosition = jQuery(window).scrollTop();
				var billboardHeight = (jQuery('.tps-body .tps-internal-billboard').length > 0) ? (jQuery('.tps-body .tps-internal-billboard').height()) : 750;
		        var offset = 100;
				if (jQuery('.sticky-bar').length) {
					if (scrollPosition > billboardHeight - offset) {
						jQuery('.tps-header').addClass('sticky-main-nav');
						jQuery('.tps-header-wrapper').addClass('sticky-main-nav');
						jQuery('.sticky-bar').removeClass('hide');
						jQuery('.menu.dropdown').addClass('hide');
						jQuery('.tps-header-wrapper .tps-header-logo').addClass('hide');
						$gt_elem.addClass('hide');
					} else {
						jQuery('.tps-header').removeClass('sticky-main-nav');
						jQuery('.tps-header-wrapper').removeClass('sticky-main-nav');
						jQuery('.sticky-bar').addClass('hide');
						jQuery('.menu.dropdown').removeClass('hide');
						jQuery('.tps-header-wrapper .tps-header-logo').removeClass('hide');
						$gt_elem.removeClass('hide');
					}
				}
		    });
		}
		});
	}
	initYTvideos() {
		jQuery('.show-more-yt').on("click", function(e) {
			e.preventDefault();
			var currentBlock = jQuery(this).data('id');
			var videoElemLength = jQuery( '.' + currentBlock +' .cell.d-none').length;
			jQuery('.' + currentBlock +' .cell.d-none').slice(0, 4).removeClass('d-none');
			jQuery('.' + currentBlock + ' .youtube-video-cta.d-none').slice(0, 1).removeClass('d-none');
			if (!jQuery('.' + currentBlock +' .cell.d-none').length) {
				jQuery('.' + currentBlock +' .show-more-cta-container').hide();
			}
		});

		jQuery(document).ready(function($) {
		    jQuery('.youtube-player-thumb').on('click', function() {
		        var youtubeWrapper = jQuery(this);
					clickedWrapper = youtubeWrapper.closest('.youtube-player-wrapper'),
					iframeSrc = youtubeWrapper.data('video-src'),
					isIOS = /(iPhone|iPad|iPod|MacIntel)/.test(navigator.platform),
					modalId = '#' + youtubeWrapper.closest('.popup-player').data('modalid');

		        if (isIOS) {
		            iframeSrc += "&mute=1";
		        }

		        resetVideo();

		        if (clickedWrapper.hasClass('popup-player')) {
		            jQuery(modalId).prepend(
		                '<iframe class="youtube-shorts-iframe youtube-player-iframe youtube-shorts-popup-iframe" enablejsapi="true" frameborder="0" width="100%" height="500" rel="0" src="'+ iframeSrc +'" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
		            );
		            jQuery(modalId).foundation('open');
		        } else {
		            youtubeWrapper.after(
		                '<iframe class="youtube-shorts-iframe youtube-player-iframe position-absolute w-100 h-100 position-top-0 position-left-0" allow="autoplay;fullscreen" playsinline="1" enablejsapi="true" frameborder="0" autostart="0" width="261" height="147" src="'+ iframeSrc +'"></iframe>'
		            );
		        }
		        clickedWrapper.addClass('playing');
		    });

		    jQuery(document).on('closed.zf.reveal', '.youtube-shorts-popup-container', function(e) {
		        resetVideo();
		    });

		    function resetVideo() {
		        jQuery('.youtube-player-wrapper').removeClass('playing');
		        jQuery('.youtube-shorts-iframe').remove();
		    }
		});

		var youtubeIntersectionObserver = new IntersectionObserver(function(entries) {
		    entries.forEach(entry => {
		        if (entry.intersectionRatio <= 0) return;

		        if (entry.isIntersecting) {
		          if(jQuery(entry.target).siblings('.d-none').length) {
		              jQuery(entry.target).siblings('.d-none').slice(0,5).removeClass('d-none');
		          }
		        }
		    });
		}, {rootMargin: "0px 0px -500px 0px"});

		const youTubeCTA = document.querySelectorAll('.youtube-videos-items-container .youtube-video-cta');
		if (youTubeCTA.length) {
		    youTubeCTA.forEach((el) => {
		        youtubeIntersectionObserver.observe(el);
		    });
		}
	}

	initLogoParadeSlider() {
		//To fix the lazyload issue.
		jQuery('.tps-logo-parade-items').animate(
			{
				"margin-left": '-100%'
			},
			{
				duration: 25000,
				easing: "linear"
			}
		);
	}

	initAllocLogin() {
		jQuery('.page-id-8583 .login-servers .btn-server-available').click(function(event) {
		    event.stopPropagation();
		    var $parent = jQuery(this).parent();
		    $parent.find('.server-list').toggleClass('d-none d-block');
		});
		jQuery('.page-id-8583 .login-servers .server-list li:not(.login-note)').click(function(event) {
			event.stopPropagation();
			jQuery(this).parent().toggleClass('d-none d-block')
			jQuery(this).siblings().removeClass('active');
			jQuery(this).addClass('active');
		});
		jQuery(document).on('click', function(event) {
		    // Check if the click happened outside the login-servers and the button
		    if (!jQuery(event.target).closest('.page-id-8583 .login-servers .server-list').length) {
		        jQuery('.page-id-8583 .login-servers .server-list').removeClass('d-block').addClass('d-none');
		    }
		});
	}

	initImagePop() {
		jQuery("body").append(`
            <div class="reveal large text-align-center" id="imagePopup" data-reveal="">
                <img src="/wp-content/themes/uptempo/assets/img/uptempo_thumb.jpg" id="modalImage" alt="Popup Image">
                <button class="close-button" data-close="" aria-label="Close modal" type="button">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
        `);

        jQuery(".image-modal-wrapper").on("click", function () {
	        var popupImage = jQuery(this).data("popup-image");
	        jQuery("#modalImage").attr("src", popupImage);
	    });
	}

	initEventAgenda() {
		jQuery(document).ready(function () {
		    jQuery(".mobile-date-alignment").prev().addClass("agenda-date-time-space");
		});
	}

	initAllocProductLogin() {
		jQuery('.page-id-3785 .server-login .btn-server-available').click(function(event) {
		    event.stopPropagation();
		    var $parent = jQuery(this).parent();
		    $parent.find('.server-list').toggleClass('d-none d-block');
		});
		jQuery('.page-id-3785 .server-login .server-list li').click(function(event) {
			event.stopPropagation();
			var $server_url = jQuery(this).data('url');
			var $server_text = jQuery(this).text();
			var $parent = jQuery(this).closest('.server-login');
			var $login_button = jQuery($parent).siblings().find('.btn-server-seleted'); 
			var $drpdown_button = jQuery($parent).find('.btn-server-available');
                            jQuery(this).parent().toggleClass('d-none d-block');

			jQuery(this).siblings().removeClass('active');
			        jQuery(this).addClass('active');
			
			$login_button.attr('href', $server_url);
			$login_button.text($server_text + ' Login');
			$drpdown_button.find('span').text('Selected '+ $server_text);
		});
		jQuery(document).on('click', function(event) {
		    // Check if the click happened outside the login-servers and the button
		    if (!jQuery(event.target).closest('.page-id-3785 .server-login .select-server').length) {
		        // If so, remove the class
		        jQuery('.page-id-3785 .server-login .server-list').removeClass('d-block').addClass('d-none');
		    }
		});
	}

        progressBar() {
		var bodyElement = jQuery('body');
	    var mainElement = jQuery('#body');
	    var bluePrintElement = mainElement.find('.single-blueprint-post-content');
	    var divElements;
	    if (bluePrintElement.length) {
		    divElements = bluePrintElement.children('div');
		} else if (mainElement.length) {
            divElements = mainElement.find('> div > div');
		}
	    var ProgressPositionValue = mainElement.attr('data-progress-position');
	    var ProgressBarColorValue = mainElement.attr('data-progress-color');
	    if (divElements.length) {

	        var isProgressOn = mainElement.hasClass('progress-on');

	        if (isProgressOn) {
	            var progressBarPosition = parseInt(ProgressPositionValue) || 1;
	            var progressBarColor = (ProgressBarColorValue);
	            if (progressBarPosition > divElements.length || progressBarPosition <= 0) {
	                progressBarPosition = 1;
	            }

	            var headerHtml = `
	                <div class="progress-container progress-position-${progressBarPosition}">
	                    <div class="main-progress-bar" style ="background-color:${progressBarColor};"></div>
	                </div>`;
	            divElements.eq(progressBarPosition - 1).before(headerHtml);

	            if (bodyElement.hasClass('logged-in')) {
	                jQuery('.progress-container').css('top', '127px');
	            }

	            jQuery(window).scroll(function() {
	                var progressBar = jQuery('.main-progress-bar');
	                var startElement = jQuery('.progress-position-' + progressBarPosition);
	                var startElementOffset = startElement.offset().top;
	                var windowHeight = window.innerHeight;
	                var scrollTop = window.scrollY || document.documentElement.scrollTop;
				    var documentHeight = jQuery(document).height();
				    var footerHeight = jQuery('footer').outerHeight() || 0;
				    var bodyHeight = documentHeight - footerHeight;
	                var rect = startElement.get(0).getBoundingClientRect();

	                if (scrollTop <= startElementOffset - windowHeight) {
	                    progressBar.css('width', '0%');
	                } else if (rect.top <= windowHeight && rect.bottom >= 0) {
                        var startScroll = startElementOffset - windowHeight;
                        var scrollDistance = scrollTop - startScroll;
				        if(window.innerWidth < 1024) {
				            var elementHeight = bodyHeight - windowHeight;
				            var progress = (scrollTop / elementHeight) * 100;
				        } else {
				            var totalHeight = documentHeight - windowHeight;
				            var progress = (scrollTop / totalHeight) * 100;
				        }
                        progress = Math.max(0, Math.min(100, progress));
                        progressBar.css('width', progress + '%');
                    }
	            });
	        }
	    }
    }

    initFAQ() {
		jQuery(document).ready(function () {
			jQuery('.upt-faq-question').click(function () {
				const $this = jQuery(this);
				const isActive = $this.hasClass('active');

				jQuery('.upt-faq-question').removeClass('active');
				jQuery('.upt-faq-answer').removeClass('open');

				if (!isActive) {
					$this.addClass('active');
					$this.next('.upt-faq-answer').addClass('open');
				}
			});
		});
    }

}
